import React from "react";

/**
 * Champ piège (« honeypot »).
 *
 * Il est présent dans le HTML mais sorti de l'écran, retiré du parcours au
 * clavier et masqué aux lecteurs d'écran : aucun visiteur ne peut le remplir.
 * Les robots qui parcourent le DOM et remplissent tout ce qui ressemble à un
 * champ texte, eux, le remplissent — le backend rejette alors la demande.
 *
 * Volontairement pas en `display:none` ni `hidden` : les robots un peu écrits
 * ignorent les champs manifestement cachés, un décalage hors écran passe mieux.
 *
 * L'identifiant doit être unique dans la page : deux formulaires affichés
 * ensemble (page de contact et fenêtre de rappel) auraient sinon le même.
 */
const ChampAntiRobot = ({ valeur, onChange, id = "website" }) => (
  <div
    aria-hidden="true"
    style={{
      position: "absolute",
      left: "-9999px",
      width: "1px",
      height: "1px",
      overflow: "hidden",
    }}
  >
    <label htmlFor={id}>Ne remplissez pas ce champ</label>
    <input
      type="text"
      id={id}
      name="website"
      value={valeur}
      onChange={onChange}
      tabIndex={-1}
      autoComplete="off"
    />
  </div>
);

export default ChampAntiRobot;
